// extracted by mini-css-extract-plugin
export default {"container":"PreparingAppLoader_container__pVUPH","loader":"PreparingAppLoader_loader__TCH8d","message":"PreparingAppLoader_message__6ZavY"};